import { styled } from "styled-components";

export const BaseButton = styled.button({
  border: 0,
  padding: 0,
  fontSize: "15px",

  "&:focus": {
    outline: 0,
  },

  "&:hover": {
    cursor: "pointer",
  },

  "&:disabled": {
    cursor: "not-allowed",
    opacity: 0.55,
    pointerEvents: "none",
  },
});

/** Button element */
export const Container = styled(BaseButton)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "0 14px",
  borderRadius: theme.radii["1"],
  fontWeight: theme.fontWeights["2"],
  whiteSpace: "nowrap",
  overflowWrap: "anywhere",
}));
